import {
    MDBTabs,
    MDBTabsContent,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsPane,
} from 'mdb-react-ui-kit';
import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import Body from "../../components/body/BodyPage";
import MainLinks from "../../components/navlinks/MainLinks";
import { Tooltip } from 'react-tooltip';
import AccountContacts from '../../components/topviews/accountsettings/AccountContacts';
import CorporateContacts from '../../components/topviews/accountsettings/CorporateContacts';
import ManageCustomFields from '../../components/topviews/accountsettings/ManageCustomFields';
import ImportGlobalContacts from '../../components/topviews/accountsettings/ImportGlobalContacts';
import { useLocation } from 'react-router';
import { show_links_tab } from '../../apiclients/apiurls';
function ContactsLanding() {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const actTab = location.state ? location.state.tab ? location.state.tab : "tab1" : "tab1";
    const [basicActive, setBasicActive] = useState(actTab);
    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }

        setBasicActive(value);
    };

    return (
        <React.Fragment>
            <>
                <MainLinks active={6} />
                <Body
                    tablinks={6}
                    sublink={275}
                    content={
                        <>
                            <section className="mb-3">
                                <div className="card card-height">
                                    <div className="card-header py-3 px-0">
                                        <h5 className="mb-0 ">
                                            {t('Contacts')}
                                        </h5>
                                    </div>
                                    <div>
                                        <MDBTabs className='mb-3'>
                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                                                    {t('Contacts')}
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab2')} active={basicActive === 'tab2'}>
                                                    {t('CorporateContacts')}
                                                </MDBTabsLink>
                                            </MDBTabsItem>

                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab3')} active={basicActive === 'tab3'}>
                                                    {t('managecustomfields')}
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                            
                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab4')} active={basicActive === 'tab4'}>
                                                    {t('importGlobalContact')}
                                                </MDBTabsLink>
                                            </MDBTabsItem>

                                        </MDBTabs>

                                        <MDBTabsContent>
                                            <MDBTabsPane open={basicActive === 'tab1'}>
                                                {/* Tab 1 content */}
                                                <AccountContacts
                                                isActive={basicActive === 'tab1'}
                                                />

                                            </MDBTabsPane>
                                            <MDBTabsPane open={basicActive === 'tab2'}>
                                                {/* Tab 2 content */}
                                                <CorporateContacts
                                                isActive={basicActive === 'tab2'}
                                                 />
                                            </MDBTabsPane>
                                            <MDBTabsPane open={basicActive === 'tab3'}>

                                                <ManageCustomFields 
                                                 isActive={basicActive === 'tab3'}
                                                />
                                            </MDBTabsPane>

                                            <MDBTabsPane open={basicActive === 'tab4'}>
                                                <ImportGlobalContacts
                                                isActive={basicActive === 'tab4'}
                                                />

                                            </MDBTabsPane>
                                        </MDBTabsContent>

                                    </div>
                                </div>
                            </section>



                        </>
                    }
                />

                <Tooltip anchorSelect=".editToolTip" place="top" className="exampleTooltip">
                    Edit
                </Tooltip>

                <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                    Remove
                </Tooltip>
            </>
        </React.Fragment>
    )
}

export default ContactsLanding